import { ChevronRight } from "lucide-react";

import { HelperArticle } from "@tudigo-monorepo/core-tudigo-api-models";
import { cn } from "@tudigo-monorepo/core-tudigo-theme";
import { useTranslation } from "@tudigo-monorepo/core-tudigo-translations";
import { ButtonRebrand } from "@tudigo-monorepo/web-tudigo-components";

export interface ArticlePreviewProps {
  article: HelperArticle;
  url: string;
  knowMore?: boolean;
  className?: string;
  onClick?: () => void;
}

export function ArticlePreview({
  article,
  knowMore = false,
  className,
  onClick,
}: ArticlePreviewProps) {
  const { t } = useTranslation();

  return (
    <ButtonRebrand
      asChild
      variant="ghost"
      textWrap="wrap"
      onClick={onClick}
      className={cn(
        "hover:border-primary-500 flex h-[120px] w-full flex-col rounded border border-neutral-200 bg-neutral-50 p-4 text-start transition-all duration-300",
        className,
      )}
      aria-label={article.name}
    >
      <div className="cursor-pointer">
        <div className="flex w-full justify-between">
          <h3 className="body300-medium text-primary-600 mb-4">
            {article.name}
          </h3>
          {!knowMore && <ChevronRight className="h-5 w-5" />}
        </div>

        <p className="body200-regular line-clamp-2 h-[35px] overflow-hidden text-ellipsis text-sm text-neutral-900">
          {article.description}
        </p>

        {knowMore && (
          <span className="text-primary-500 body300-medium w-full py-3 text-right">
            {t("component.helper_article_preview.know_more")}
          </span>
        )}
      </div>
    </ButtonRebrand>
  );
}
